<input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
(change)="onFileSelected($event)" #fileUpload required>

<ng-container *ngIf="!editingBlogPost">
    <h2>{{selectedBlogPost?.title}}</h2>
    <p><label class="fixed-size">Title:</label> <strong>{{selectedBlogPost?.title}}</strong></p>
    <p><label class="fixed-size">Content:</label> <label class="indent"><strong>{{selectedBlogPost?.content}}</strong></label></p>

    <button class="primary-button" type="add" (click)="this.editBlogPost()">Edit BlogPost</button>
</ng-container>
<ng-container *ngIf="editingBlogPost">
    <h2>Editing:  {{selectedBlogPost?.title}}<button class="delete-button" type="delete" (click)="this.removeBlogPost()">Delete BlogPost</button></h2>
    <br>
    <form [formGroup]="blogPostForm">
        <label class="fixed-size" for="title">Title: </label>
        <input id="title" type="text" formControlName="title">
        <br>
        <label class="fixed-size" for="author">Author: </label>
        <input id="author" type="text" formControlName="author">
        <br>
        <div *ngIf="newFile != undefined; else noFile">
          <label class="fixed-size" for="blogPost-image">BlogPost Image: </label>
          <label>{{newFileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
        </div>
        <ng-template #noFile>
          <label  for="blogPost-image">Replace BlogPost Image: </label>
          <button class="add-button" (click)="fileUpload.click()">New Image</button>
        </ng-template>
        <br>
        <label for="content">Content: </label><br>
        <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
          formControlName="content"></textarea>
        <br>
      </form>
      <form [formGroup]="blogPostForm" (ngSubmit)="submitBlogPostEdits()"></form>
      <p>Note: To add a link to your blog post follow this format:<br> &lt;a href="link"&gt;Text to Click&lt;/a&gt;</p>
      <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
      <button class="primary-button" type="submit" [disabled]="!blogPostForm.valid" (click)="this.submitBlogPostEdits()">Submit</button>
</ng-container>